export const prettyError = (message: string, locale: string): string => {
  // TODO: match this with server and prettify
  if (locale === "nl") {
    return "Er is iets misgegaan. Probeer het opnieuw"
  } else {
    return "Something went wrong. Please try again"
  }
}
